import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const imageWidth = 110;

const style = () => {
  const {
    borderWidth1,
    borderWidth2,
    borderRadius3,
    colorBorderInteractive,
    colorBorderInteractiveSelected,
    space2,
    space4,
    space6,
  } = theme();

  return StyleSheet.create({
    content: {
      paddingLeft: space6,
      paddingRight: space6,
    },
    image: {
      borderColor: colorBorderInteractive,
      borderRadius: borderRadius3,
      borderWidth: borderWidth1,
      height: 92,
      width: 74,
    },
    imageWrapper: {
      paddingRight: space2,
    },
    selectedImage: {
      borderColor: colorBorderInteractiveSelected,
      borderWidth: borderWidth2,
    },
    wrapper: {
      marginBottom: space4,
    },
  });
};

export { style, imageWidth };
